<template>
    <div class="card-container" ref="card">
        <div class="card" :style="style" ref="cardInner">
            <img
                v-show="!hideImage"
                class="card-img-top"
                :src="model.image"
                :alt="model.fullname"
            />
            <div class="card-body">
                <h3>{{ model.fullname }}</h3>

                <template v-if="configuration.price">
                    <table class="table table-borderless">
                        <tr>
                            <td>
                                {{ $t("engine_price") }}
                            </td>
                            <td>
                                <currency
                                    :value="configuration.engine_price"
                                ></currency>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                {{ $t("options_price") }}
                            </td>
                            <td>
                                +
                                <currency
                                    :value="configuration.options_price"
                                ></currency>
                            </td>
                        </tr>

                        <tr class="total">
                            <td>
                                {{ $t("total") }}
                            </td>
                            <td>
                                <currency
                                    :value="configuration.price"
                                ></currency>
                                <small>(+ IVA)</small>
                            </td>
                        </tr>
                    </table>
                </template>
                <pulse-loader :loading="!configuration.price"></pulse-loader>

                <div class="buttons-group">
                    <button
                        class="btn btn-success btn-sm mb-2"
                        @click="onOffer()"
                    >
                        {{ $t("request_offer") }}
                    </button>
                    <button
                        class="btn btn-success btn-sm mb-2"
                        @click="onEmail()"
                    >
                        {{ $t("send_configuration") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.card-container {
    position: absolute;
    width: 100%;
    background: red;
}
.card {
    width: 100%;
    position: absolute;
    top: 0;
    margin-top: 1rem;
    transition: top 200ms;
    transition-delay: 50ms;
}
.buttons-group {
    text-align: center;
}
.total {
    font-size: 1.2em;
    font-weight: bold;
}
</style>

<script>
import IframeEventsMixin from "../mixins/IframeEvents";
export default {
    mixins: [IframeEventsMixin],

    props: {
        configuration: {
            type: Object,
            required: true,
        },
    },

    data: function () {
        return {
            scrollY: 0,
            model: null,
            showCb: null,
            visible: true,
            scrolling: false,
            hideImage: false,
        };
    },

    created: function () {
        if (this.isIframe) {
            this.onMessageBinding = this.onMessage.bind(this);
            window.addEventListener("message", this.onMessageBinding);
        } else {
            this.onScrollBinding = this.onScroll.bind(this);
            window.addEventListener("scroll", this.onScrollBinding);
        }

        this.model = this.configuration.model;
        this.$watch("configuration.model", () => {
            this.model = this.configuration.model;
        });

        this.$watch("configuration.price", () => {
            this.sendEvent({
                type: "priceChange",
                price: this.configuration.price,
            });
        });
    },

    mounted() {
        this.onResize();
        this.onResizeBinding = this.onResize.bind(this);
        window.addEventListener("resize", this.onResizeBinding);
    },

    destroyed() {
        window.removeEventListener("resize", this.onResizeBinding);
        if (this.isIframe) {
            window.removeEventListener("message", this.onMessageBinding);
        } else {
            window.removeEventListener("scroll", this.onScrollBinding);
        }
    },

    computed: {
        isHidden() {
            return this.configuration.price <= 0;
        },

        isIframe() {
            return window.top != window;
        },

        style() {
            return { top: this.scrollY + "px" };
        },
    },

    methods: {
        onResize() {
            if (window.innerHeight < this.$refs.cardInner.offsetHeight) {
                this.hideImage = true;
            }
        },

        onOffer() {
            this.$events.$emit("request-offer", this.configuration);
        },

        onEmail() {
            this.$events.$emit("send-email", this.configuration);
        },

        onScroll() {
            let offsetTop = this.$refs.card.getBoundingClientRect
                ? this.$refs.card.getBoundingClientRect().top
                : 0;

            let scrollY = Math.max(0, -offsetTop);

            this.scrollY = scrollY;

            this.onResize();
        },

        onMessage(event) {
            if (event.data.type == "scrollParent") {
                let offsetTop = this.$refs.card.getBoundingClientRect
                    ? this.$refs.card.getBoundingClientRect().top
                    : 0;

                let scrollY = Math.max(
                    0,
                    Math.min(
                        event.data.scrollY - offsetTop,
                        window.innerHeight - event.data.height
                    )
                );

                this.scrollY = scrollY;

                this.onResize();
            }
        },
    },
};
</script>
